import Link from '@visa/vds/link';
import React from 'react';
import { connect } from 'react-redux';
import { hideDivBasedOnId, showDivBasedOnId } from '../../../../../commons/ui-commons';
import { getPrimaryColor } from '../../../../../themeprovider/actions/themes-provider';
import { setBodyLevelSelectedTab } from '../js/live-console';
import {getMethodType} from "../../../../../lhs/reducers/lhs-reducer";

/**
 * Request description in live console tab 
 */
var hasBodyParams = false;


class UrlEditorInLiveConsole extends React.Component {

    render() {
        return (
            <li id="url-data" style={{ display: 'flex', marginTop: '15px', marginBottom: '10px', marginLeft: '15px' }}>
                <span style={{ fontWeight: 'bold', fontSize: '14px' }}>{getMethodType()? getMethodType().toUpperCase(): "URL"}:</span>
                <span style={{ marginLeft: '10px', overflowWrap: 'anywhere' }}>{this.props.apiUrl}</span>
                <div class="changeLink" style={{ marginLeft: '10px' }}>
                    <Link tabindex="0" class="changeConfig color_theme_link"
                        onClick={() => {
                            showDivBasedOnId('tab-Configuration');
                            hideDivBasedOnId('tab-Request-Builder');
                            if (this.props.hasBodyParams) {
                                setBodyLevelSelectedTab(1);
                            }
                            else {
                                setBodyLevelSelectedTab(0);
                            }
                            var elementUrl = document.getElementById("urlLabel");
                            if (elementUrl != null) {
                                elementUrl.scrollIntoView();
                            }
                            document.querySelector('#urlEditor > div').click();
                            document.querySelector('#urlEditor > div').style.borderColor = getPrimaryColor().split('!')[0].trim();
                            setTimeout(function() {
                                document.querySelector('#urlEditor > div').style.borderColor = 'rgb(34,34,34)'
                            },5000);
                        }}
                    >Change
                    </Link>
                </div>
            </li>
        );

    }
}
function mapStateToProps(state) {
    hasBodyParams = (state.lhsReducer.hasBodyParams == undefined) ? false : state.lhsReducer.hasBodyParams;


    return {
        hasBodyParams: hasBodyParams,
        path :state.lhsReducer.path,
        apiUrl :state.rhsReducer.apiUrl    
    };

}

export default connect(mapStateToProps)(UrlEditorInLiveConsole);